var map = {
	"./DashboardMap.svg": 721,
	"./MenuAreas.svg": 722,
	"./MenuAutomaticAssigment.svg": 723,
	"./MenuBtb.svg": 724,
	"./MenuCargo.svg": 725,
	"./MenuConfigurations.svg": 726,
	"./MenuConsumers.svg": 727,
	"./MenuCustomers.svg": 728,
	"./MenuDashboard.svg": 729,
	"./MenuDriverDebtor.svg": 730,
	"./MenuDrivers.svg": 731,
	"./MenuGroups.svg": 732,
	"./MenuHUB.svg": 733,
	"./MenuLogisticPartners.svg": 734,
	"./MenuMap.svg": 735,
	"./MenuOrders.svg": 736,
	"./MenuOrdersManagement.svg": 737,
	"./MenuPricing.svg": 738,
	"./MenuServices.svg": 739,
	"./MenuSms.svg": 740,
	"./MenuSolver.svg": 741,
	"./MenuSolverJobs.svg": 742,
	"./MenuStatistic.svg": 743,
	"./MenuStatistics.svg": 744,
	"./MenuVeh.svg": 745,
	"./MenuVoucher.svg": 746,
	"./MenuWaybills.svg": 747,
	"./SMS.svg": 748,
	"./Settings.svg": 749,
	"./cargo.svg": 750,
	"./drivers.svg": 751,
	"./mapIcons/Blue.svg": 537,
	"./mapIcons/Green.svg": 538,
	"./mapIcons/Logo.svg": 752,
	"./mapIcons/Yellow.svg": 539,
	"./mapIcons/blueCircleMarker.svg": 532,
	"./mapIcons/blueTruckMarker.svg": 527,
	"./mapIcons/greenCircleMarker.svg": 540,
	"./mapIcons/mapPin.svg": 364,
	"./mapIcons/redCircleMarker.svg": 533,
	"./mapIcons/yellowCircleMarker.svg": 541,
	"./mapOutsideMarker.svg": 753,
	"./partners.svg": 754,
	"./waybills.svg": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1143;